import { CommonModule } from '@angular/common';
import { Component, ViewChild, ElementRef } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { TicketService } from '../../shared/services/ticket.service';
import {
  ApiResponseTicket,
  TicketAttachment,
  TicketAttachmentAux,
  TicketComment,
  TicketDetail,
  TicketTemplate,
} from '../../shared/models/ticket-model/tiket.model';
import { ActivatedRoute } from '@angular/router';
import { format } from 'date-fns';
import { FormControl, Validators } from '@angular/forms';
import { LoadGeneralComponent } from '../../shared/components-generals/load-general/load-general.component';
import { environment } from '../../../environments/environment';
import { FileDownloadService } from '../../shared/services/file-download.service';
import { GeneralService } from '../../shared/services/general.service';
import { catchError, firstValueFrom, forkJoin, Observable, of, switchMap } from 'rxjs';
import { InputGeneralTextComponent } from '../../shared/inputs/input-general-text/input-general-text.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { MatDialog } from '@angular/material/dialog';
import { ModalViewFileComponent } from '../../shared/modals/modal-view-file/modal-view-file.component';
import { DetailInfoTicket } from '../detail-info-ticket/detail-info-ticket';
import { TranslateModule } from '@ngx-translate/core';
@Component({
  selector: 'app-detail-request',
  imports: [
    MatIcon,
    MatButtonModule,
    CommonModule,
    LoadGeneralComponent,
    InputGeneralTextComponent,
    GoogleMapsModule,
    DetailInfoTicket,
    TranslateModule,
  ],
  templateUrl: './detail-request.html',
  styleUrl: './detail-request.css',
})
export class DetailRequest {
  public center: google.maps.LatLngLiteral = { lat: 24, lng: 12 };
  public zoom = 9;
  public controlComment: FormControl = new FormControl('', [Validators.required]);
  public ticketDetail: TicketDetail | null = null;
  public ticketDetailStart: TicketDetail | null = null;
  public folio: string | null = null;
  public loadService = false;
  public URL_API = environment.apiURLNew;
  public fileInput!: HTMLInputElement;
  public allComments: TicketComment[] = [];
  public ticketTemplate: TicketTemplate[] = [];
  public allComentsAndTemplates: (TicketComment | TicketTemplate)[] = [];
  public allAttachments: TicketAttachment[] = [];
  public lastTicketId: number = 0;
  public isFallasWorkFlow = false;

  constructor(
    private dialog: MatDialog,
    private route: ActivatedRoute,
    public ticketService: TicketService,
    private generalService: GeneralService,
    private fileDownloadService: FileDownloadService,
  ) {}

  ngOnInit(): void {
    this.route.queryParamMap.subscribe((params) => {
      this.folio = params.get('Folio');
      if (this.folio) {
        this.loadService = true;
        this.ticketSearch(this.folio);
      }
    });
  }

  public ticketSearch(id: string): void {
    this.ticketService
      .ticketSearch({ SearchField: 'ODT', SearchFieldValue: id, Page: 1, PageSize: 9999 })
      .subscribe((response) => {
        if (response) {
          this.isFallasWorkFlow = response.Data.Items[0]?.WorkFlowType === 'FALLAS';

          const ticketService: Observable<ApiResponseTicket<TicketDetail> | null>[] = [];
          response.Data.Items.forEach((ticket) => {
            ticketService.push(this.ticketService.getTicketDetail(ticket.Id.toString()));
          });
          this.ticketService
            .getTicketTemplate({
              SearchField: 'WorkFlowProject',
              SearchFieldValue: id,
              Page: 1,
              PageSize: 10000,
            })
            .subscribe((templateResponse) => {
              if (templateResponse && templateResponse.Data) {
                this.ticketTemplate = templateResponse.Data.Items;

                this.getTicketServiceDetail(ticketService);
              }
            });
        }
      });
  }

  public getTicketServiceDetail(
    ticketService: Observable<ApiResponseTicket<TicketDetail> | null>[],
  ): void {
    this.generalService.getServices(ticketService).then((details) => {
      // Ordenar detalles por Id ascendente

      if (details && details.length > 0) {
        // Filtrar solo TicketDetail válidos
        const orderDetail: TicketDetail[] = details
          .map((d) => d?.Data)
          .filter((d): d is TicketDetail => !!d)
          .sort((a, b) => (a.Id > b.Id ? 1 : -1));
        // Fusionar y mapear Comments y Attachments
        this.allComments = [];
        this.allAttachments = [];

        orderDetail.forEach((detail, idx) => {
          if (detail) {
            this.center = {
              lat: Number(detail.Location.Latitude) || 24,
              lng: Number(detail.Location.Longitude) || 12,
            };
          }

          if (detail.Comments) {
            this.allComments = this.allComments.concat(
              detail.Comments.map((c: any) => ({ ...c, TicketId: idx })),
            );
          }

          if (detail.Attachments) {
            this.allAttachments = this.allAttachments.concat(
              detail.Attachments.map((a: any) => ({ ...a, TicketId: idx })),
            );
            this.orderDateAttachments();
          }
        });

        let allComentsAndTemplates = [...this.allComments, ...this.ticketTemplate];

        this.allComentsAndTemplates = this.orderDate(allComentsAndTemplates);

        this.lastTicketId = orderDetail.length > 0 ? orderDetail[orderDetail.length - 1].Id : 0;
        this.ticketDetail = orderDetail[orderDetail.length - 1] || null;
        this.ticketDetailStart = orderDetail[0] || null;

        this.getFiles(this.allAttachments);
        if (this.allAttachments.length === 0) {
          this.loadService = false;
        }
      }
    });
  }

  private orderDate(colection: any[]): any[] {
    return colection.sort((a, b) => {
      const parseCustomDate = (dateStr: string): number => {
        if (!dateStr) return 0;

        try {
          const parts = dateStr.toLowerCase().split(' ');
          const datePart = parts[0];
          const timePart = parts[1];
          const ampm = parts[2] + (parts[3] || '');
          const [day, month, year] = datePart.split('/');
          let [hours, minutes, seconds] = timePart.split(':').map(Number);
          if (ampm.includes('p') && hours < 12) hours += 12;
          if (ampm.includes('a') && hours === 12) hours = 0;
          return new Date(
            Number(year),
            Number(month) - 1,
            Number(day),
            hours,
            minutes,
            seconds,
          ).getTime();
        } catch (e) {
          console.error('Error parseando fecha:', dateStr);
          return 0;
        }
      };
      const timeA = parseCustomDate(a.CreateDate);
      const timeB = parseCustomDate(b.CreateDate);
      return timeB - timeA;
    });
  }

  private orderDateAttachments() {
    this.allAttachments.sort((a, b) => {
      const parseUploadDate = (dateStr: string): number => {
        if (!dateStr) return 0;

        try {
          // 1. Separar Fecha de Hora
          // Entrada: "27/03/2026 13:53:18"
          const [datePart, timePart] = dateStr.split(' ');

          // 2. Extraer día, mes, año
          const [day, month, year] = datePart.split('/');

          // 3. Extraer hora, minutos, segundos
          const [hours, minutes, seconds] = timePart.split(':');

          // 4. Crear la fecha usando el constructor numérico (año, mes-1, dia, hora, min, seg)
          // Nota: El mes en JS es 0-indexed (enero es 0)
          return new Date(
            Number(year),
            Number(month) - 1,
            Number(day),
            Number(hours),
            Number(minutes),
            Number(seconds),
          ).getTime();
        } catch (e) {
          return 0;
        }
      };

      const timeA = parseUploadDate(a.UploadDate);
      const timeB = parseUploadDate(b.UploadDate);

      // Orden descendente: del más nuevo al más viejo
      return timeB - timeA;
    });
  }

  private getFiles(TicketAttachment: TicketAttachment[]): void {
    const attachment = TicketAttachment.map((attachment: any) =>
      this.ticketService.getFile(attachment.DownloadUrl),
    );

    console.log(attachment);
    this.generalService.getServices(attachment).then((results) => {
      console.log('Archivos obtenidos:', results);
      const preFiles = results.map((result) => {
        console.log('Procesando archivo para attachment:', result);
        if (result && result.Data && result.Data.Url) {
          const fileName = result.Data.FileName;
          const contentType = result.Data.ContentType;
          const contentMD5 = result.Data.MD5;
          return this.fileDownloadService.getFileFromUrlAlternal(
            result.Data.Url,
            fileName,
            contentType,
            contentMD5,
          );
        }
        return of(null);
      });
      console.log('Observables para obtener archivos:', preFiles);
      this.generalService.getServices(preFiles).then((files) => {
        console.log('Archivos procesados:', files);
        files.forEach((file, index) => {
          const attachment = TicketAttachment[index];
          if (file && this.isImageByFileName(file.name)) {
            attachment.file = URL.createObjectURL(file);
          }
        });
        this.loadService = false;
      });
    });
  }

  public createTicketComment(): void {
    this.loadService = true;
    const body = {
      CommentTypeId: 1,
      TicketId: Number(this.ticketDetail?.Id),
      Comment: this.controlComment.value,
      CurrentDate: this.getCurrentDateString(),
    };
    this.ticketService.createTicketComment(body).subscribe((response) => {
      if (response) {
        this.controlComment.reset();
        this.ticketSearch(this.folio ?? '');
      }
    });
  }
  public createTicketTemplate(): void {
    this.loadService = true;
    const body = {
      Description: '',
      Content: this.controlComment.value || '',
      TemplateId: null,
      TicketId: Number(this.ticketDetail?.Id || 0),
      Username: localStorage.getItem('Username') ?? '',
    };
    this.ticketService.createTicketTemplate(body).subscribe((response) => {
      if (response) {
        this.controlComment.reset();
        this.ticketSearch(this.folio ?? '');
      }
    });
  }

  public getCurrentDateString(): string {
    const now = new Date();
    return format(now, 'dd/MM/yyyy HH:mm:ss');
  }

  public async getFile(url: string): Promise<File | void> {
    const response = await this.ticketService.getFile(url).toPromise();
    if (response && response.Data && response.Data.Url) {
      const fileName = response.Data.FileName;
      const contentType = response.Data.ContentType;
      const contentMD5 = response.Data.MD5;
      const file = await this.fileDownloadService.getFile(
        response.Data.Url,
        fileName,
        contentType,
        contentMD5,
      );
      return file;
    } else {
      return;
    }
  }

  public downloadFile(url: string): void {
    this.ticketService.getFile(url).subscribe((response) => {
      if (response && response.Data && response.Data.Url) {
        const fileName = response.Data.FileName;
        const contentType = response.Data.ContentType;
        const contentMD5 = response.Data.MD5;
        this.fileDownloadService.downloadFile(response.Data.Url, fileName, contentType, contentMD5);
      }
    });
  }

  public downloadFileUPS(assetPath: string): void {
    const url = `/assets/${assetPath}`;
    const fileName = assetPath.split('/').pop() || 'Guía de UPS.pdf';
    fetch(url)
      .then((response) => response.blob())
      .then((blob) => {
        // Crear un enlace temporal para descargar el archivo
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        setTimeout(() => {
          document.body.removeChild(link);
          URL.revokeObjectURL(link.href);
        }, 100);
      });
  }

  triggerFileInput(): void {
    const input = document.createElement('input');
    input.type = 'file';
    input.style.display = 'none';
    input.addEventListener('change', (event: any) => this.onFileSelected(event));
    document.body.appendChild(input);
    input.click();
    setTimeout(() => document.body.removeChild(input), 1000);
  }

  onFileSelected(event: any): void {
    const file: File = event.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => {
      const base64 = (reader.result as string).split(',')[1];
      // Validar tamaño máximo 50 MB
      const maxSizeMB = 50;
      const maxSizeBytes = maxSizeMB * 1024 * 1024;
      if (file.size > maxSizeBytes) {
        // Mostrar alerta usando viewSnacAlert

        this.generalService.viewSnacAlert(
          'El archivo excede el tamaño máximo permitido de 50 MB.',
          'error',
          'Archivo demasiado grande',
        );

        return;
      }
      let sanitizedFileName = file.name
        .normalize('NFD') // quita acentos
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, '_') // espacios → _
        .replace(/[^a-zA-Z0-9._-]/g, '') // ❗ elimina TODO lo no permitido
        .replace(/\.{2,}/g, '.') // evita muchos puntos seguidos
        .replace(/^\.|\.$/g, ''); // evita punto al inicio o final
      this.createTicketAttachment(base64, sanitizedFileName);
    };
    reader.readAsDataURL(file);
  }

  public createTicketAttachment(FileContent: string, FileName: string): void {
    this.loadService = true;
    this.ticketService
      .createTicketAttachment({
        TicketId: Number(this.ticketDetail?.Id),
        FileName: FileName,
        FileContent: FileContent,
      })
      .subscribe((response) => {
        this.ticketSearch(this.folio ?? '');
      });
  }

  public back(): void {
    this.generalService.goToUrl(['home'], { statusSelected: 1 }, true);
  }

  public isImageByFileName(fileName: string): boolean {
    if (!fileName) return false;
    const lower = fileName.toLowerCase();
    return (
      lower.endsWith('.jpg') ||
      lower.endsWith('.jpeg') ||
      lower.endsWith('.png') ||
      lower.endsWith('.gif') ||
      lower.endsWith('.webp') ||
      lower.endsWith('.bmp') ||
      lower.endsWith('.svg')
    );
  }

  public isPdfByFileName(fileName: string): boolean {
    if (!fileName) return false;
    const lower = fileName.toLowerCase();
    return lower.endsWith('.pdf');
  }

  public isVideoByFileName(fileName: string): boolean {
    if (!fileName) return false;
    const lower = fileName.toLowerCase();
    return (
      lower.endsWith('.mp4') ||
      lower.endsWith('.avi') ||
      lower.endsWith('.mov') ||
      lower.endsWith('.mkv')
    );
  }

  public viewFileLight(url: string): void {
    this.getFile(url).then((file) => {
      if (!file) return;
      const name = file.name || 'Archivo';
      this.dialog.open(ModalViewFileComponent, {
        width: '80vw',
        maxWidth: '80vw',
        maxHeight: '95vh',
        height: '95vh',
        disableClose: false,
        autoFocus: false,
        data: {
          Titule: 'Archivo ' + name,
          file: file,
        },
      });
    });
  }
}
